import React, { Component } from 'react';
import config from 'config/api';
import Immutable from 'immutable';
import BlockButton from 'components/UI/BlockButton';
import Input from 'components/UI/Form/Input';
import RemainingTime from 'components/UI/RemainingTime';
import BlockTitle from 'components/UI/BlockTitle';
// import { formatDate } from 'helpers/stringUtils'
import getRemainingTime from 'helpers/getRemainingTime';
// import colors from 'config/colors'
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import i18n from 'helpers/i18n';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
// import getCardImage from 'helpers/getCardImage'
// import Grid from '@material-ui/core/Grid';
// import List from '@material-ui/core/List';
// import ListItem from '@material-ui/core/ListItem';
// import ListItemText from '@material-ui/core/ListItemText';
// import ListItemAvatar from '@material-ui/core/ListItemAvatar';
// import Avatar from '@material-ui/core/Avatar';
// import EventSubscriptionRecapSingle from "components/EventSubscription/EventSubscriptionRecapSingle";
import IconWarning from '@material-ui/icons/Warning';
// import IconCheck from '@material-ui/icons/Check';
const styles = (theme) => ({
  addButton: {
    backgroundColor: 'transparent',
    padding: 0,
    boxShadow: '0 5px 20px rgba(0,0,0,0.21)',
    '&:hover': {
      boxShadow: '0 5px 5px rgba(0,0,0,0.21)',
      backgroundColor: 'transparent',
    },
  },
  addIcon: {
    width: 50,
    height: 50,
    color: '#EB9250',
    verticalAlign: 'middle',
    margin: '-5px',
  },
  mainColor: {
    color: '#585854',
  },
  altColor: {
    color: '#47B42A',
  },
  colorTitle: {
    color: theme.palette.primary.main,
    marginBottom: '20px',
  },
  actionButtons: {
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(4),
    },
  },
  submitButton: {
    transition: [
      theme.transitions.create('color', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      theme.transitions.create('opacity', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    ],
    backgroundImage: 'none',
    color: theme.palette.text.light,
    backgroundColor: theme.palette.primary.main,
    fontSize: 22,
    fontWeight: 'bold',
    letterSpacing: '1px',
    padding: '8px 50px',
    border: '1px transparent solid',
    // display: "flex",
    '&:hover': {
      backgroundImage: 'none',
      border: '1px ' + theme.palette.primary.main + ' solid',
      backgroundColor: '#fff',
      color: theme.palette.primary.main,
    },
  },
});
class EventSubscription extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sending: false,
      log: false,
      email: '',
      complete: false,
    };
    this._send = this._send.bind(this);
    this._onEmailChange = this._onEmailChange.bind(this);
    // this.onEventSelectionReset =
  }
  _onEmailChange(kind, target) {
    this.setState({
      email: target.value,
    });
  }
  _validateEmail($$field, value) {
    let check = true;
    if (value !== undefined) check = !!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value);
    const log = check === true ? undefined : 'Le champs ' + $$field.get('label') + ' est invalide';
    return log;
  }
  _send(e) {
    const {
      $$user,
      // $$events,
      // onClose,
      registerFor,
      showRecap,
      onSubscriptionComplete,
      onSubscriptionRequest,
    } = this.props;
    const { sending } = this.state;
    if (sending === true) return;
    let url;
    if (this.props.unsubscribe === true) url = config.eventUnsubscribe;
    else url = config.eventSubscribe;
    var formData = new FormData();
    const $$events = onSubscriptionRequest();
    // console.log($$events, $$event)
    // const formEvents = $$events !== undefined ? $$events.map(f => f.get('id')).toArray() :
    // Immutable.fromJS([]);
    // console.log({
    //   $$events,
    //   test: $$events.toJS(),
    // });
    if ($$events.size === 1) formData.append('rid', $$events.get(0));
    else if ($$events.size > 0) formData.append('rids', JSON.stringify($$events));
    else return;
    // to reset events in api
    // formData.append("rids", JSON.stringify([null]));
    this.setState({
      sending: true,
      log: false,
    });
    if (registerFor === true) {
      const check = this._validateEmail(
        Immutable.fromJS({
          label: 'Email',
        }),
        this.state.email,
      );
      if (check !== undefined) {
        // console.log('NOT OK', check)
        this.setState({
          log: check,
          sending: false,
        });
        return;
      } else {
        // console.log('check ok')
        formData.append('remail', this.state.email);
      }
    } else {
      formData.append('remail', $$user.get('id'));
    }
    return fetch(url, {
      credentials: 'include',
      method: 'POST',
      headers: {
        Accept: 'application/json, application/xml, text/plain, text/html, *.*',
        'X-Requested-With': 'XMLHttpRequest', // needed by php api
      },
      body: formData,
    })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        if (
          response.registration &&
          (response.registration === 'complete' || response.registration === 'already')
        ) {
          // if (this.props.onClose) this.props.onClose();
          if (showRecap !== false)
            this.setState({
              complete: true,
              sending: false,
              email: '',
              sentEmail: this.state.email,
            });
          else if (onSubscriptionComplete !== undefined) onSubscriptionComplete();
        } else if (response.registration && response.registration === 'unknown_subsriber') {
          if (this.props.onSubscriptionError)
            this.props.onSubscriptionError('unknown_subsriber', {
              email: this.state.email,
            });
        } else if (response.registration && response.registration === 'already') {
          if (this.props.onSubscriptionError)
            this.props.onSubscriptionError('already', {
              email: this.state.email,
            });
        } else {
          this.setState({
            sending: false,
          });
        }
      });
  }
  render() {
    const {
      // $$event,
      // $$events,
      classes,
      unsubscribe,
      registerFor,
      showRecap,
      userRole,
      onClose,
      onSelectionReset,
      hasSubscribed,
      onCancel,
    } = this.props;
    const {
      // visibleMode,
      sending,
      log,
      complete,
    } = this.state;
    // console.log('events', $$events)
    // const timeRemaining =
    //   $$event !== undefined ? getRemainingTime($$event.get("eventDate")) : {};
    const { email, sentEmail } = this.state;
    // let image;
    let buttonLabel;
    if (unsubscribe === true) {
      buttonLabel = 'SE DESINSCRIRE';
    } else if (registerFor !== true)
      // buttonLabel = 'S\'INSCRIRE +';
      buttonLabel = i18n.get('subscriptionFormSelfButton', {
        pretty: false,
      });
    else buttonLabel = 'Envoyer une invitation';
    // console.log('DEBUG', $$event)
    return (
      <div className="Form">
        {/* <If condition={$$event !== undefined}>
        <Box align="center">
        <Typography
        variant="h2"
        classes={{ root: classes.colorTitle }}
        gutterBottom
        >
        La conférence débute dans
        </Typography>
        <RemainingTime
        days={timeRemaining.days}
        hours={timeRemaining.hours}
        minutes={timeRemaining.minutes}
        />
        </Box>
        </If>
        <If condition={$$events !== undefined}>
        <If condition={registerFor === undefined}>
        <Box align="middle" my={4}>
        <Typography variant="h2" gutterBottom={true}>
        {i18n.get("subscriptionSelfTitle")}
        </Typography>
        </Box>
        </If>
        <If condition={registerFor !== undefined}>
        <Box align="middle" my={4}>
        <Typography variant="h2" gutterBottom={true}>
        {i18n.get("subscriptionForTitle")}
        </Typography>
        </Box>
        </If>
        <EventSubscriptionRecapSingle
        $$events={$$events}
        onSelectionReset={onSelectionReset}
        />
        </If> */}

        <If condition={complete !== true && showRecap !== false}>
          {/* <If
            condition={
            registerFor === undefined && i18n.has("subscriptionSelfText")
            }
            >
            <Typography variant={"body1"} gutterBottom>
            {i18n.get("subscriptionSelfText")}
            </Typography>
            </If>
            <If
            condition={
            registerFor !== undefined && i18n.has("subscriptionForText")
            }
            >
            <Typography variant={"body1"} gutterBottom>
            {i18n.get("subscriptionForText")}
            </Typography>
            </If>*/}
        </If>

        <If condition={registerFor === true}>
          <Box align="center" mt={5} mb={3}>
            <Typography variant={'body1'} gutterBottom>
              {i18n.get('subscriptionForText')}
            </Typography>
            <Box display="inline-block" mb={3}>
              <Input
                name="email"
                id="email"
                value={email !== false ? email : null}
                label="Email"
                onChange={this._onEmailChange}
                style={{ maxWidth: 280, margin: '0 auto' }}
                fullWidth={true}
              />
            </Box>
          </Box>
        </If>

        <If condition={log !== undefined && log !== false}>
          <Typography variant="body1" className="red" gutterBottom={true} align="center">
            {log}
          </Typography>
        </If>

        <If condition={complete === true}>
          <Box mb={3}>
            <If condition={unsubscribe === true}>
              <Typography variant="h5" classes={{ root: classes.mainColor }} gutterBottom>
                <IconWarning
                  style={{
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    width: 40,
                    height: 40,
                    marginTop: '-8px',
                    color: '#EB9250',
                  }}
                  classes={{ root: classes.mainColor }}
                />{' '}
                Désinscription enregistrée{' '}
              </Typography>
            </If>
            <If condition={unsubscribe !== true}>
              <Typography variant="h4" classes={{ root: classes.altColor }} align="center" gutterBottom>
                {i18n.get('subscription' + (registerFor !== undefined ? 'For' : '') + 'SuccessTitle', {
                  substitute: { '@recipient@': sentEmail },
                })}
              </Typography>

              <If
                condition={i18n.has(
                  'subscription' + (registerFor !== undefined ? 'For' : '') + 'SuccessText',
                )}
              >
                <Typography variant={'h5'} align="center" gutterBottom>
                  {i18n.get('subscriptionForSuccessText')}
                </Typography>
              </If>
            </If>
          </Box>
        </If>

        <If condition={sending !== true}>
          <Box>
            <If condition={unsubscribe === true}>
              <BlockButton
                label={'Annuler'}
                variant="white"
                style={{ display: 'inline-block', margin: '0 5px' }}
                onClick={onClose}
                disabled={sending}
              ></BlockButton>
            </If>
            <If condition={unsubscribe !== true && userRole === 'member'}></If>
            <Box className={classes.actionButtons}>
              <Button className={classes.submitButton} onClick={this._send} disabled={sending}>
                {buttonLabel}
              </Button>
            </Box>
          </Box>
        </If>
      </div>
    );
  }
}
// export default ;
export default withStyles(styles)(EventSubscription);



// WEBPACK FOOTER //
// ./src/components/EventSubscription/EventSubscription.jsx